import PrefixEnum from '../prefixes'

export default Object.freeze({
    'bootybylisa.gymondo.fitness': PrefixEnum.LISA,
})
